var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83333 4.83333C9.83333 6.67428 8.34095 8.16667 6.5 8.16667C4.65905 8.16667 3.16667 6.67428 3.16667 4.83333C3.16667 2.99238 4.65905 1.5 6.5 1.5C8.34095 1.5 9.83333 2.99238 9.83333 4.83333Z",
    fill: "#7B61FF",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.6667C3.73858 10.6667 1.5 12.9052 1.5 15.6667V16.5H11.5V15.6667C11.5 12.9052 9.26142 10.6667 6.5 10.6667Z",
    fill: "#7B61FF",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6.5V9M14 9V11.5M14 9H16.5M14 9H11.5M9.83333 4.83333C9.83333 6.67428 8.34095 8.16667 6.5 8.16667C4.65905 8.16667 3.16667 6.67428 3.16667 4.83333C3.16667 2.99238 4.65905 1.5 6.5 1.5C8.34095 1.5 9.83333 2.99238 9.83333 4.83333ZM1.5 15.6667C1.5 12.9052 3.73858 10.6667 6.5 10.6667C9.26142 10.6667 11.5 12.9052 11.5 15.6667V16.5H1.5V15.6667Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.1487e2b73065ed33f426417dd87499f8.svg";
export { ForwardRef as ReactComponent };